import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1f2e8df1"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=1f2e8df1&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f2e8df1')) {
      api.createRecord('1f2e8df1', component.options)
    } else {
      api.reload('1f2e8df1', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1f2e8df1", function () {
      api.rerender('1f2e8df1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sportManage/basic/index.vue"
export default component.exports